import { Mapper } from "../../../../base/utils/mapper";
import { TypeLicenseModel } from "../../../../domain/models/comercial/type-license.model";
import { TypeLicenseEntity } from "../entities/type-license.entity";


export class TypeLicenseImplementationRepositoryMapper extends Mapper<TypeLicenseEntity, TypeLicenseModel> {
    mapFrom(param: TypeLicenseEntity): TypeLicenseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeLicenseModel): TypeLicenseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}